module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/address-card-098c08012f10b4da19e4ed56bee2d570.svg";